import type { AiAnalysisState } from './aiAnalysisTypes';

export const QUICKNOTE_OPTIONS = [
  { value: 'review', label: 'Review later', icon: '📋' },
  { value: 'suspicious', label: 'Suspicious', icon: '🚨' },
  { value: 'conflicting', label: 'Conflicting info', icon: '⚠️' },
  { value: 'evidence', label: 'Key evidence', icon: '🔍' },
  { value: 'followup', label: 'Follow up needed', icon: '📞' },
  { value: 'witness', label: 'Witness statement', icon: '👁️' },
  { value: 'timeline', label: 'Timeline important', icon: '⏱️' },
  { value: 'custom', label: 'Custom...', icon: '✏️' },
] as const;

export const initialState: AiAnalysisState = {
  suggestedActions: [],
  queuedActions: [],
  allSuggestedActions: [],
  discardedSuggestions: [],
  resolvedSuggestions: [],
  removedSuggestions: [],
  partialSuggestions: [],
  answeredPrompts: [],
  partialPrompts: [],
  detectedPrompts: [],
  fadingPrompts: [],
  lockedPrompts: [],
  failedPrompts: [],
  pinnedItems: [],
  relatedDocumentsSnapshot: [],
  relatedDocumentsOverallSummary: null,
  mapLayerConfig: null,
  pendingQuickNotes: [],
  aiQueries: [],
  aiSearches: [],
  entities: {
    caller: {
      name: "",
      address: "",
      phone: "",
      dob: ""
    },
    incident: undefined,
    officers: [],
    people: [],
    organizations: [],
    locations: [],
    objects: [],
    activity: [],
    policiesAndLaws: [],
    other: [],
    connections: {
      relationships: []
    }
  },
  activityFeed: {
    events: []
  },
  // Extraction error tracking
  extractionErrors: {},
  // Stable display ordering
  displayOrder: [],
  lastReorderTime: 0,
  // Prioritization tracking
  lastTranscriptChangeTime: 0,
  lastItemsChangeTime: 0,
  lastPriorityChangeTimes: {},
  // Entity freshness tracking
  entityCategoryLastUpdate: {},
  analysisStartedAt: null,
  analysisHydrating: false,
  entityPassSettled: false,
  canonicalRevision: 0,
  canonicalStateRevision: 0,
  forceGenerateAcks: [],
};
